document.addEventListener("DOMContentLoaded", function() {
    const bannerVideo = document.querySelector('.banner-video');
    if (!bannerVideo) return; // Exit if bannerVideo doesn't exist

    const iframe = bannerVideo.querySelector('.video-iframe');

    bannerVideo.addEventListener('click', function() {
        if (!iframe.src) {
            iframe.src = iframe.getAttribute('data-src');
        }
        bannerVideo.classList.add('active');
    });
});
